import { DEFAULT_LOCALE } from 'app/features/localization/constants';
import { routerLocales } from 'app/router/constants/routerLocales';

const routeToLocale = Object.fromEntries(
  Object.entries(routerLocales).map(([key, value]) => [value, key]),
);

const localeFromPathname = () => {
  const splitPathname = window.location.pathname.split('/');
  const maybeLocale = routeToLocale[`/${splitPathname[1]}`];

  return maybeLocale || DEFAULT_LOCALE;
};

export default localeFromPathname;
